import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
//import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
//import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
//import LinearProgress from "@material-ui/core/LinearProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

// @material-ui/lab components
//import AvatarGroup from "@material-ui/lab/AvatarGroup";
//import Pagination from "@material-ui/lab/Pagination";
// @material-ui/icons components
import MoreVert from "@material-ui/icons/MoreVert";
// core components
import componentStyles from "assets/theme/components/cards/tables/card-light-table-tables.js";

const useStyles = makeStyles(componentStyles);

const tableHead = ["Id","Course Name", "Batch", "Status", "Total content", "Teacher", "Starting Date",""];
const tableBody = [
  {
    Id:1,
    courseName: "aws basics",
    batch: "january",
    status: "active",
    color: "bgWarning",
    totalContent: 3,
    teacher: "ali hamza",
    
  },
  
];

const DropdownComponent = ({id,course_id,batch_id }) => {
  const theme = useTheme();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleContent = (event) => {
    
    history.push({
      pathname: '/admin/Addcontent',
      state: { course_id, batch_id }
    });
  };

  
  const handleContent2 = (event) => {
    
    history.push({
      pathname: '/admin/ViewContent',
      state: { course_id, batch_id }
    });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Box
        aria-controls={"simple-menu-" + id}
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
        component={Button}
        width="2rem!important"
        height="2rem!important"
        minWidth="2rem!important"
        minHeight="2rem!important"
      >
        <Box
          component={MoreVert}
          width="1.25rem!important"
          height="1.25rem!important"
          position="relative"
          top="2px"
          color={theme.palette.gray[500]}
        />
      </Box>
      <Menu
        id={"simple-menu-" + id}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose}>View Enrolled Students</MenuItem>
        <MenuItem onClick={handleContent}>Add Contents</MenuItem>
        <MenuItem onClick={handleContent2}>View Contents</MenuItem>
      
      </Menu>
    </>
  );
};



export default function CardLightTableTables() {
  
  const history = useHistory();
  const classes = useStyles();
  const [courses, setCourses] = useState([
    {
      course_id: 0,
      course_name: 'No content',
      course_description: 'No content available',
      course_teacher: 'No content',
      batch_id: 1,
      batch_name: 'No content',
      status: 'passive',
      created_at: '2024-08-05T10:39:21.000Z',
      total_lectures: 0
    }
  ]);
  const [error, setError] = useState(null);
  useEffect(() => {
  
    var token = localStorage.getItem("token");
  
    const fetchData = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/validate-token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ token }),
        });
  
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
  
        const data = await res.json();
        if (data.valid === false) {
          history.push("/auth/login");
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };


    const fetchAssignedCourses = async () => {
      try {
        const response = await fetch('https://server.thelanofficial.com/Assigned-Courses', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();

        if (!data.valid) {
          setError(data.message);
        } else {
          setCourses(data.courses);
        }
      } catch (err) {
        console.error('Error fetching assigned courses:', err);
        setError('Error fetching assigned courses');
      }
    };

    fetchAssignedCourses();
    fetchData();
  
  }, []);
  return (
    <>
      <Card classes={{ root: classes.cardRoot }}>
        <CardHeader
          className={classes.cardHeader}
          title="Assigned Courses"
          titleTypographyProps={{
            component: Box,
            marginBottom: "0!important",
            variant: "h3",
          }}
        ></CardHeader>
        <TableContainer>
          <Box component={Table} alignItems="center" marginBottom="0!important">
            <TableHead>
              <TableRow>
                {tableHead.map((prop, key) => (
                  <TableCell
                    key={key}
                    classes={{
                      root:
                        classes.tableCellRoot + " " + classes.tableCellRootHead,
                    }}
                  >
                    {prop}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
            {courses
            .filter((course) => course.status === 'passive')
            .map((prop, key) => (
                <TableRow key={key}>
                  <TableCell
                    classes={{
                      root:
                        classes.tableCellRoot +
                        " " +
                        classes.tableCellRootBodyHead,
                    }}
                    component="th"
                    variant="head"
                    scope="row"
                  >
                    <Box alignItems="center" display="flex">
                      
                      <Box display="flex" alignItems="flex-start">
                        <Box fontSize=".875rem" component="span">
                        {prop.course_id}
                        </Box>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                  {prop.course_name}
                  </TableCell>

                  <TableCell classes={{ root: classes.tableCellRoot }}>
                  {prop.batch_name}
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                      <Box
                        marginRight="10px"
                        component="i"
                        width=".375rem"
                        height=".375rem"
                        borderRadius="50%"
                        display="inline-block"
                        className={
                          classes.verticalAlignMiddle +
                          " " +
                          classes["bgWarning"]
                        }
                      ></Box>
                      {prop.status}
                    </Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                 
                  &ensp;&ensp;&ensp;{prop.total_lectures}&ensp;videos
                     
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box display="flex" alignItems="center">
                      <Box component="span">
                        {prop.course_teacher}
                      </Box>
                      
                    </Box>
                  </TableCell>


                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box display="flex" alignItems="center">
                      <Box component="span">
                      {new Date(prop.created_at).toLocaleDateString()}
                      </Box>
                      
                    </Box>
                  </TableCell>
                  <TableCell
                    classes={{ root: classes.tableCellRoot }}
                    align="right"
                  >
                    <DropdownComponent id={key} course_id={prop.course_id} batch_id={prop.batch_id} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Box>
        </TableContainer>
       
      </Card>
    </>
  );
}
